"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var WhaleVote_1 = __importDefault(require("../../../Icons/Notifications/WhaleVote"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "A wallet holding over 250k VP has just",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "cast a vote"),
            ". Stay informed and see how this significant vote impacts the outcome.")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "A whale voted on your proposal \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"")); }
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Una billetera con m\u00E1s de 250k VP acaba de",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "emitir un voto"),
            ". Mantente informado y revisa c\u00F3mo este voto significativo impacta el resultado.")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Una ballena vot\u00F3 en tu propuesta \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"")); }
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u4E00\u4E2A\u6301\u6709\u8D85\u8FC725\u4E07VP\u7684\u94B1\u5305\u521A\u521A\u6295\u7968\u3002"),
            "\u4FDD\u6301\u5173\u6CE8\uFF0C\u770B\u770B\u8FD9\u4E00\u91CD\u8981\u6295\u7968\u5982\u4F55\u5F71\u54CD\u6700\u7EC8\u7ED3\u679C\u3002")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u4E00\u4F4D\u9CB8\u9C7C\u5BF9\u60A8\u7684\u63D0\u6848\"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"\u8FDB\u884C\u4E86\u6295\u7968")); }
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var GovernanceWhaleVoteNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(WhaleVote_1.default, null) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title(notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceWhaleVoteNotification;
